import Vue from 'vue';
import Router from 'vue-router';

import MainView from '@/views/main-view.vue';
import AdminRoutes from './admin';
import { DataFormDesignRoute, FunctionDesignRoutes } from './design';
import Error from '@/views/error.vue';
import { ReportRootRoute, ReportBackStageRoute } from './report.js';
import { ApplicationFunctionDesign } from './application-function-design';

import LoginService from '@/services/login.service';
import OrganizationManager from '@/services/organization-manager.service';
import { Base64 } from 'js-base64';
import systemService from '@/services/system-service';

Vue.use(Router);

const Home = () =>
    import(/* webpackChunkName: "home-component" */ '@/components/home-component.vue');
const AppDetail = () =>
    import(/* webpackChunkName: "app-detail" */ '@/views/app-detail/app-detail.vue');
const HomeDesign = () =>
    import(/* webpackChunkName: "homedesign" */ '@/views/back-stage/homedesign/homedesign.vue');
const ReleaseLog = () =>
    import(/* webpackChunkName: "releaselog" */ '@/views/back-stage/releaselog/releaselog.vue');

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: MainView,
            children: [
                {
                    path: '',
                    name: 'home',
                    component: Home,
                },
                {
                    path: '/app/:appCode/:appItemCode?/:appItemTitle?',
                    name: 'app',
                    component: AppDetail,
                },
                {
                    path: '/homedesign/:id',
                    name: 'homedesign',
                    component: HomeDesign,
                },
                ReportBackStageRoute,
                ApplicationFunctionDesign,
                {
                    path: '/releaselog',
                    name: 'releaselog',
                    component: ReleaseLog,
                },
                ...FunctionDesignRoutes,
            ],
        },
        AdminRoutes,
        DataFormDesignRoute,
        ...ReportRootRoute,
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
        },
        {
            path: '/dataform',
            name: 'data-form',
            component: () =>
                import(/* webpackChunkName: "data-form" */ '@/views/data-form/data-form.vue'),
        },
        {
            path: '/flowstate',
            name: 'flow-state',
            component: () =>
                import(/* webpackChunkName: "flow-state-view" */ '@/views/flow-state/flow-state-view.vue'),
        },
        {
            path: '/oauth-callback',
            name: 'oauthCallback',
            component: () =>
                import(/* webpackChunkName: "oauth-callback" */ '@/views/oauth-callback'),
        },
        {
            path: '/error',
            name: 'error',
            component: Error,
        },
        {
            path: '*',
            redirect: '/',
        },
    ],
});

router.beforeEach((to, _, next) => {
    if (
        to.name === 'oauthCallback' ||
        to.name == 'login' ||
        (LoginService.isLogin && !LoginService.isTimed() && !to.query.authcode)
    ) {
        next();
        return;
    }

    if (to.query.authcode) {
        LoginService.loginByAuthCode(
            to.query.authcode,
            to.query.systemCode,
            window.location.href,
            function(bool) {
                if (bool) {
                    delete to.query.authcode;
                    delete to.query.systemCode;
                    router.push({
                        name: to.name,
                        path: to.path,
                        params: to.params,
                        query: to.query,
                    });
                    next();
                } else {
                    // router.push({
                    //     name: 'login',
                    // });
                    pushKjjLoginView();
                }
            }
        );
    } else if (to.query.tokenid) {
        //第三方通过tokenid登陆
        LoginService.loginbyTokenId(to.query.tokenid).then(res => {
            if (res.Status) {
                next();
            } else {
                // router.push({
                //     name: 'login',
                // });
                pushKjjLoginView();
            }
        });
    } else if (to.query.ryid) {
        //**** */?ryid={usercode} 登陆
        LoginService.loginByLoginCode(to.query.ryid, function(bool) {
            if (bool) {
                next();
            } else {
                // router.push({
                //     name: 'login',
                // });
                pushKjjLoginView();
            }
        });
    } else if (LoginService.isLogin && !LoginService.isTimed()) {
        if (to.meta && to.meta.roleCode) {
            OrganizationManager.isRoleByCode(to.meta.roleCode).then(res => {
                if (res && res.Result) {
                    next();
                } else {
                    router.push({
                        name: 'error',
                        query: {
                            message: '没有访问权限',
                        },
                    });
                }
            });
        } else {
            next();
        }
    } else if (LoginService.isLogin && LoginService.isTimed()) {
        let url = location.pathname + location.search;
        let returnUrl = Base64.encodeURI(url);
        LoginService.logout(returnUrl);
    } else {
        // let url = location.pathname + location.search;
        // let returnUrl = Base64.encodeURI(url);
        // router.push({
        //     name: 'login',
        //     query: {
        //         returnUrl,
        //     },
        // });
        pushKjjLoginView();
    }
});

function pushKjjLoginView() {
    systemService.getEntOrganizationInfo().then(info => {
        if (info && info.LogoutUrl) {
            const urls = info.LogoutUrl.split('?');
            const url = urls && urls.length ? urls[0] : info.LogoutUrl;
            const sourceUrl = Base64.encode(window.location.href);
            window.location.href = `${url}?sourceUrl=${sourceUrl}`;
        }
    });
}

export default router;
